module.exports = __webpack_public_path__ + "img/info.56190fd9.svg";